














import { Vue, Component, Prop } from "vue-property-decorator";

@Component
export default class InfoMessage extends Vue {
  @Prop(String) text: string;

  expanded = false;

  get truncatedText() {
    return this.text.substr(0, 58) + "...";
  }

  toggleMessage() {
    this.expanded = !this.expanded;
  }

  shrinkMessage() {
    this.expanded = false;
  }
}
